// Office/History:

// {{{ CDR.UnavailableRecordingDialog

GW.define('CDR.UnavailableRecordingDialog', 'Main.Dialog', {
	title: _('Nahrávka nedostupná'),
	subtitle: _('Tato nahrávka již v úložišti není dostupná'),

	'after:initComponent'() {
		this.footerEl.gwReplaceChildren([{
			className: 'form-buttons',
			children:[{
				nodeName: 'button',
				className: 'primary',
				textContent: _('Rozumím'),
				'on:click': () => {
					this.destroy();
				},
			}],
		}]);
	},
});

// }}}
// {{{ AudioPlayerButton

GW.define('AudioPlayerButton', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				ref: 'audioEl',
				nodeName: 'audio',
				preload: 'none',
				'on:play': () => this.updateState(),
				'on:ended': () => this.updateState(),
				'on:pause': e => this.updateState(),
				'on:error': e => this.onLoadError(e),
				src: this.audioUrl,
			}, {
				ref: 'revBtn',
				nodeName: 'button',
				type: 'button',
				className: 'small secondary icon-only rew-button paused',
				children: [Utils.useIcon('fi-rewind')],
				tabIndex: -1,
				'on:click': () => this.seekRelative(-10),
			}, {
				ref: 'playBtn',
				nodeName: 'button',
				type: 'button',
				className: 'small secondary icon-only play-button',
				children: [{
					ref: 'iconWrapEl',
					className: 'icon-wrapper',
					children: [Utils.useIcon('play')]
				}, {
					ref: 'progressEl',
					className: 'progress'
				}],
				'on:click': () => this.play(),
			}, {
				ref: 'fwdBtn',
				nodeName: 'button',
				type: 'button',
				className: 'small secondary icon-only fwd-button paused',
				children: [Utils.useIcon('fi-fast-forward')],
				tabIndex: -1,
				'on:click': () => this.seekRelative(10),
			}],
		}, this);

		this.monDom(this.audioEl, 'timeupdate', e => this.onTimeUpdate(e));
	},

	releaseComponent() {
		this.audioEl.pause();
		this.audioEl.removeAttribute('src');
	},

	$key_ArrowLeft() {
		this.seekRelative(-10);
	},

	$key_ArrowRight() {
		this.seekRelative(10);
	},

	$key_Escape(ev) {
		this.stop();
		this.audioEl.currentTime = 0;
	},

	onLoadError(ev) {
		this.updateState();
	},

	onTimeUpdate(e) {
		if (Math.floor(e.target.currentTime) % 2 === 0) {
			this.el.title = Utils.secondsToHoursMinutes(e.target.currentTime || 0) +
				' / ' + Utils.secondsToHoursMinutes(e.target.duration || 0);
		}

		this.progressEl.style.width = Math.ceil((e.target.currentTime / e.target.duration) * 100) + '%';
	},

	updateState() {
		let active = !this.audioEl.paused && !this.audioEl.ended && !this.audioEl.error;

		this.revBtn.classList.toggle('paused', !active);
		this.fwdBtn.classList.toggle('paused', !active);
		this.revBtn.setAttribute('tabIndex', active ? 0 : -1);
		this.fwdBtn.setAttribute('tabIndex', active ? 0 : -1);
		this.iconWrapEl.gwReplaceChildren(
			[!active ? Utils.useIcon('play') : {
				nodeName: 'img',
				src: APP_BASE + 'img/dialing-animation.gif',
				className: 'icon',
			}]
		);
		// When user seeks via keyboard very fast, audio `ended` event
		// doesn't fire (just paused event is fired)
		if (this.audioEl.ended) {
			this.el.removeAttribute('title');

			setTimeout(() => {
				this.progressEl.style.width = 0;
			}, 250);
		}
	},

	async play() {
		let audio = this.audioEl;

		this.fire('beforeplay');

		try {
			if (audio.paused) {
				// Try to recover from fast seeking via keyboard
				if (audio.readyState < 4) {
					audio.load();
				}

				await audio.play();
			} else {
				audio.pause();
			}
		} catch (ex) {
			if (audio.error && audio.error.message.match(/404/)) {
				Application.notify({
					kind: 'error',
					text: _('Soubor s nahrávkou již neexistuje'),
				});
				return;
			}

			throw ex;
		}
	},

	seekRelative(diff) {
		let audio = this.audioEl;

		audio.currentTime = Math.min(Math.max(audio.currentTime + diff, 0), audio.duration);
	},

	stop() {
		this.audioEl.pause();
	},
});

// }}}
// {{{ CDR.CallRecordingsTable

GW.define('CDR.CallRecordingsTable', 'SmartTable', {
	emptyText: _('Tento hovor nemá žádné nahrávky'),
	recordingsBaseUrl: null,

	getColumns() {
		let me = this;

		return [{
			id: 'caller',
			name: _('Volající'),
		}, {
			id: 'caller_name',
			name: _('Jméno'),
		}, {
			id: 'callee',
			name: _('Volaný'),
		}, {
			id: 'callee_name',
			name: _('Jméno'),
		}, {
			id: 'start_ts',
			name: _('Začátek záznamu'),
			format: 'datetime',
		}, {
			id: 'ctl',
			name: _('Akce'),
			formatCell(td, v, row) {
				if (!row.readable) {
					td.textContent = _('Záznam nedostupný');
					return;
				}

				td.gwCreateChild({
					xtype: 'AudioPlayerButton',
					audioUrl: me.recordingsBaseUrl + row.recording_id,
					'on:beforeplay': c => {
						me.stopAllRecordings(c);
					},
				});

				if (Application.getActiveUserGroups()
					.some(g => g.member_role != 'agent' || g.options.allow_recordings_download)
				) {
					td.gwCreateChild({
						nodeName: 'a',
						className: 'button small secondary icon-only',
						children: [Utils.useIcon('download')],
						href: me.recordingsBaseUrl + row.recording_id + '?download=1',
						download: '',
					});
				}
			}
		}];
	},

	stopAllRecordings(except) {
		this.getChildren(c => c !== except && c instanceof AudioPlayerButton, true)
			.forEach(c => c.stop());
	},
});

// }}}
// {{{ CDR.CallRecordingsDialog

GW.define('CDR.CallRecordingsDialog', 'Main.Dialog', {
	title: _('Nahrávky'),

	'after:initComponent'() {
		this.bodyEl.gwCreateChild({
			ref: 'table',
			xtype: 'CDR.CallRecordingsTable',
			recordingsBaseUrl: this.recordingsBaseUrl,
		}, this);
	},

	setRecordings(recs) {
		this.table.setData(recs);
	},
});

// }}}
// {{{ CDR.CallCategoryDialog

GW.define('CDR.CallCategoryDialog', 'Main.FormDialog', {
	title: _('Změnit kategorii'),
	hierarchy: null,
	disableConfirmIfNoneSelected: false,

	'before:initComponent'() {
		this.title += ' - ' + this.hierarchy.name;
	},

	'after:initComponent'() {
		this.el.classList.add('cdr-call-category-change-dialog');

		this.categoriesField.setCategoryList(this.hierarchy.categories);
		this.focus();

		if (this.disableConfirmIfNoneSelected) {
			// initially disabled, enable on category set if needed
			this.buttonConfirm.disabled = true;
		}
	},

	renderFormFields() {
		return [{
			ref: 'categoriesField',
			name: 'category',
			xtype: 'Office.CallPanel.CategorySelector',
			'on:change': el => {
				if (this.disableConfirmIfNoneSelected) {
					this.buttonConfirm.disabled = el.getValue() == null; 
				}
			},
			validate() {
				return true;
			},
		}];
	},

	getSelectedCategories() {
		return this.categoriesField.getSelectedCategories();
	},
});

// }}}
// {{{ CDR.HistoryScreen

GW.define('CDR.HistoryScreen', 'Main.Screen', {
	title: _('CDR'),
	titleIcon: 'phone-calls-filled',
	full: false,

	'after:initComponent'() {
		let me = this;

		this.el.classList.add('cdr-history-screen');
		this.bodyEl.gwReplaceChildren([{
			ref: 'toolbarEl',
			nodeName: 'form',
			'on:submit': ev => {
				ev.preventDefault();
				this.reload();
			},
			className: 'toolbar',
			children: this.renderToolbar(),
		}, {
			ref: 'table',
			xtype: 'FilterableSmartTable',
			extraClass: 'panel-container no-padding cdr-smart-table',
			getColumns() {
				const columns = me.getAllColumns();

				const order = (localStorage.getItem('cdr-columns-order') || '').split(',').filter(s => s != '');
				const hidden = new Set((localStorage.getItem('cdr-columns-hidden') || '').split(','));

				return (order.length ? order.map(id => columns.find(col => col.id == id)).filter(c => c) : columns)
					.filter(col => !hidden.has(col.id));
			},
			renderRow(tr, row) {
				tr.dataset.direction = row.direction || '';
				tr.dataset.result = row.result || '';
			},
		}], this);

		setTimeout(() => {
			// help firefox
			let el = this.el.querySelector('[autofocus]');
			el && el.focus();
		}, 0);

		for (let f of this.getLiveToolbarSearchFields()) {
			f.on('change', c => this.updateParams());
		}
	},

	getLiveToolbarSearchFields() {
		return this.getChildren(c => {
			return c.fromParams && c.toParams && c.toQuery && c.el.closest('.toolbar');
		});
	},

	/*
	 * PLUGIN: extension point
	 */
	getColumns() {
		return [{
			id: 'direction',
			name: _('Směr'),
			formatCell(td, v, row) {
				td.gwCreateChild(Office.renderDirectionIcon(row, true));
				td.gwCreateChild(Formats.call_direction(v));
			},
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
				value: v => Formats.call_direction(v),
			}
		}, {
			id: 'start',
			format: 'datetime',
			name: _('Začátek hovoru'),
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'early_duration',
			format: 'duration',
			name: _('Čas v IVR'),
			filter: {
				type: 'duration',
			},
			sortable: {
				type: 'numeric'
			},
		}, {
			id: 'ring_duration',
			format: 'duration',
			name: _('Délka vyzvánění'),
			filter: {
				type: 'duration',
			},
			sortable: {
				type: 'numeric'
			},
		}, {
			id: 'duration',
			format: 'duration',
			name: _('Délka hovoru'),
			filter: {
				type: 'duration',
			},
			sortable: {
				type: 'numeric'
			},
		}, {
			id: 'queue',
			name: _('Vstupní fronta'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'last_queue',
			name: _('Poslední fronta'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'caller',
			name: _('Volající'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'caller_name',
			name: _('Jméno'),
			fullName: _('Jméno volajícího'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'caller_company',
			name: _('Firma'),
			fullName: _('Firma volajícího'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'callee',
			name: _('Volaný'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'callee_name',
			name: _('Jméno'),
			fullName: _('Jméno volaného'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'callee_company',
			name: _('Firma'),
			fullName: _('Firma volaného'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'last_callee',
			name: _('Poslední volaný'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'last_callee_name',
			name: _('Jméno'),
			fullName: _('Jméno posledního volaného'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'last_callee_company',
			name: _('Firma'),
			fullName: _('Firma posledního volaného'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'transfer',
			name: _('Přepojení'),
			format: 'transfer_type',
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
				value: v => Formats.transfer_type(v),
			},
		}, {
			id: 'did',
			name: _('Vstupní číslo'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'result',
			name: _('Výsledek hovoru'),
			format: 'call_result',
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
				value: v => Formats.transfer_type(v),
			},
		}, {
			id: 'source',
			name: _('Zdroj'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string'
			}
		}, {
			id: 'category1',
			name: _('Kategorie 1'),
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'category2',
			name: _('Kategorie 2'),
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
			},
		}];
	},

	getAllColumns() {
		let me = this;

		if (this.full) {
			return this.getColumns().concat({
				id: 'acl',
				name: _('ACL'),
				formatCell(td, v, row) {
					if (!v || v.length == 0) {
						return;
					}

					td.gwCreateChild({
						nodeName: 'button',
						className: 'small secondary icon-only btn-notes',
						children: [Utils.useIcon('document')],
						title: _('Zobrazit ACL'),
						'on:click': async ev => {
							me.showACLDialog(v);
						},
					});
				},
			});
		}

		return this.getColumns().concat(this.getDetailsColumn());
	},

	async showACLDialog(acl) {
		let users = await REST.GET('users');
		let groups = await REST.GET('user-groups');
		let userMap = new Map(users.map(v => [String(v.id), v.name]));
		let groupMap = new Map(groups.map(v => [String(v.id), v.name]));

		let rows = acl.map(n => {
			let m;
			if (m = n.match(/^G(\d+)$/)) {
				return {
					id: n,
					map: groupMap.get(m[1]) || '-',
				};
			} else if (m = n.match(/^M(\d+)\/(\d+)$/)) {
				return {
					id: n,
					map: (groupMap.get(m[1]) || '-') + ' / ' + (userMap.get(m[2]) || '-'),
				};
			} else if (m = n.match(/^U(\d+)$/)) {
				return {
					id: n,
					map: userMap.get(m[1]) || '-',
				};
			}

			return {id: n};
		});

		new Main.Dialog({
			title: _('ACL hovoru'),

			'after:initComponent'() {
				this.bodyEl.gwCreateChild({
					xtype: 'SmartTable',
					getColumns() {
						return [{
							id: 'id',
							name: _('ID'),
						}, {
							id: 'map',
							name: _('Jméno'),
						}];
					},
					rows,
				});
			},
		});
	},

	getDetailsColumn() {
		let me = this;

		return {
			id: 'details',
			name: _('Detaily'),
			filter: {
				type: 'options',
				options: [{
					value: 'notes',
					title: _('Obsahuje poznámku'),
				}, {
					value: 'category',
					title: _('Obsahuje kategorii'),
				}, {
					value: 'recordings',
					title: _('Obsahuje nahrávky'),
				}, {
					value: 'nothing',
					title: _('Neobsahuje nic'),
				}],
				matches(val, filter_val, row) {
					if (filter_val.length === 4) {
						return true;
					}

					if (row.has_recordings && filter_val.includes('recordings')) {
						return true;
					}

					if (row.call_category && filter_val.includes('category')) {
						return true;
					}

					if (row.has_notes && filter_val.includes('notes')) {
						return true;
					}

					if (!row.has_recordings && !row.call_category && !row.has_notes && filter_val.includes('nothing')) {
						return true;
					}

					return false;
				},
			},
			formatCell(td, v, row) {
				me.renderCallIcons(td, row);
			},
			sortable: {
				type: 'string',
				value: (v, row) => {
					return [
						row.has_notes,
						row.call_category,
						row.has_recordings,
					].map(b => b ? '0' : '1').join();
				},
			},
		};
	},

	/*
	 * PLUGIN: extension point for search
	 */
	renderToolbarSearchFields() {
		return [{
			xtype: 'Widgets.DateRangeInput',

			fromParams(params) {
				let range = params.get('range') || 'today';

				this.setRangeOption(range);

				if (range == 'custom') {
					this.setTimeRange(
						params.get('since'),
						params.get('until')
					);
				}
			},
			toParams(params) {
				let range = this.getRange();
				if (range == 'custom') {
					let [since, until] = this.getTimeRange();
					params.set('since', since || '');
					params.set('until', until || '');
					params.delete('range');
				} else {
					params.delete('since');
					params.delete('until');
					params.set('range', range);
				}

				this.updateTimeFields();
			},
			toQuery(query) {
				let [since, until] = this.getTimeRange();

				query.since = since;
				query.until = until;
			},
		}, {
			xtype: 'TextField',
			extraClass: 'small',
			label: _('Telefon'),
			optional: true,

			fromParams(params) {
				this.setValue(params.get('number') || '');
			},
			toParams(params) {
				let number = this.getValue() || '';
				if (number) {
					params.set('number', number);
				} else {
					params.delete('number');
				}
			},
			toQuery(query) {
				query.extension = this.getValue() || undefined;
			},
		}, {
			xtype: 'TextField',
			extraClass: 'small',
			label: _('Vstupní fronta'),
			optional: true,

			fromParams(params) {
				this.setValue(params.get('queue') || '');
			},
			toParams(params) {
				let queue = this.getValue() || '';
				if (queue) {
					params.set('queue', queue);
				} else {
					params.delete('queue');
				}
			},
			toQuery(query) {
				query.queue = this.getValue() || undefined;
			},
		}];
	},

	renderToolbar() {
		return [...this.renderToolbarSearchFields(), {
			nodeName: 'button',
			type: 'submit',
			className: 'primary small',
			textContent: _('Zobrazit'),
		}, {
			nodeName: 'button',
			type: 'button',
			className: 'secondary small icon-only',
			children: [Utils.useIcon('settings')],
			'on:click': () => {
				let hidden = new Set((localStorage.getItem('cdr-columns-hidden') || '').split(','));
				let order = (localStorage.getItem('cdr-columns-order') || '').split(',').filter(s => s != '');
				let me = this;
				
				const columns = () => me.getAllColumns().map(c => {
					return {
						id: c.id,
						title: c.fullName || c.name,
						selected: !hidden.has(c.id) && (!order.length || order.includes(c.id)),
					};
				});

				new Main.ListSelectDialog({
					title: _('Nastavení sloupců'),
					selectAllText: _('Zobrazit vše'),
					unselectAllText: _('Skrýt vše'),

					items: columns().sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id)),

					'wrap:renderFormButtons'(fn) {
						return [...(this.reorderAllowed ? [{
							ref: 'resetOrderBtn',
							nodeName: 'button',
							type: 'button',
							className: 'secondary ' + (this.items.map(i => i.id).join(',') == columns().map(c => c.id) ? 'hidden' : ''),
							textContent: _('Resetovat pořadí'),
							'on:click': ev => {
								this.setItems(columns());
								this.resetOrderBtn.classList.add('hidden');
							},
						}] : []), ...fn()];
					},

					onDragEnd() {
						this.resetOrderBtn.classList.remove('hidden');
					},
					
					onSave({selected, order}) {
						let hide = new Set(me.getAllColumns().map(c => c.id));
						for (let id of selected) {
							hide.delete(id);
						}

						localStorage.setItem('cdr-columns-hidden', [...hide].join(','));
						localStorage.setItem('cdr-columns-order', order.join(','));

						me.table.refresh();
					},
				});
			},
		}, {
			nodeName: 'button',
			type: 'button',
			className: 'secondary small',
			textContent: _('Exportovat XLSX'),
			"on:click": () => {
				let params = new URLSearchParams(JSON.parse(JSON.stringify(this.buildQuery())));
				let group = Application.getActiveUserGroup();
				if (group) {
					params.set('active_user_group', group.id);
				}

				location.href = API_BASE + 'calls/export/xlsx?' + params.toString();
			},
		}];
	},

	/*
	 * PLUGIN: extension point
	 */
	renderCallIcons(td, call) {
		td.gwCreateChild({
			nodeName: 'button',
			className: 'small secondary icon-only btn-notes',
			children: [Utils.useIcon(call.has_notes ? 'documentwithcontentfilled' : 'document')],
			title: call.has_notes ? _('Zobrazit poznámky') : _('Přidat poznámku'),
			'on:click': ev => this.showCallCard(call, td),
		});
		
		if (call.last_queue_has_category_hierarchy && call.result == 'connected') {
			td.gwCreateChild({
				nodeName: 'button',
				ref: 'btnCategory',
				className: 'small secondary icon-only  btn-category',
				children: [Utils.useIcon(call.call_category ? 'categoryfilled' : 'categoryempty')],
				title: call.call_category ? _('Zobrazit Kategorie') : _('Přidat Kategorie'),
				'on:click': ev => this.editCategory(call, ev.target.closest('tr')),
			});
		} else {
			// This button is used merely as a non-visual padding element
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only vhidden',
				disabled: true,
			});
		}
		
		if (call.has_recordings) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only',
				children: [Utils.useIcon('dialing')],
				title: call.recordings_readable ? _('Zobrazit nahrávky') : _('K nahrávkám nemáte přístup'),
				disabled: !call.recordings_readable,
				'on:click': ev => this.showRecordings(call),
			});
		} else {
			// This button is used merely as a non-visual padding element
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only vhidden',
				disabled: true,
			});
		}
	},

	async editCategory(call, tr) {
		if (!call.last_queue) {
			Application.notify({
				kind: 'warning',
				text: _('Kategorii lze změnit jen u frontového hovoru.'),
			});
			return;
		}

		let hierarchy;
		try {
			hierarchy = await REST.GET('queues/' + encodeURIComponent(call.last_queue) + '/call-category-hierarchy');
		} catch (ex) {
			if (ex.status == 404) {
				Application.notify({
					kind: 'warning',
					text: _('Fronta {queue} nemá přiřazenu skupinu kategorií.')
						.replace('{queue}', call.last_queue),
				});
				return;
			}

			throw ex;
		}

		let dlg = new CDR.CallCategoryDialog({
			hierarchy,

			async onSave(data) {
				await REST.PUT('call-info/' + encodeURIComponent(call.id), data);

				let cats = this.getSelectedCategories();

				call.call_category = cats;

				tr.querySelector('td[data-col=category1]').textContent = (cats && cats[0]) ? cats[0].name : '';
				tr.querySelector('td[data-col=category2]').textContent = (cats && cats[1]) ? cats[1].name : '';
				
				tr.querySelector('td[data-col=details] .btn-category').gwReplaceChildren([
					Utils.useIcon(cats ? 'categoryfilled' : 'categoryempty')
				]);
			},
		});

		dlg.setFormFieldsData({
			category: call.call_category || [],
		});
	},

	async showCallCard(call, td) {
		const call_data = {
			call_id: call.id,
			phone: call.caller && call.caller.number,
		};

		// preload the data before showing the dialog to avoid UI flicker
		let data = await REST.GET('call-info/' + encodeURIComponent(call_data.call_id), {phone: call_data.phone});
		
		new Main.Dialog({
			title: _('Poznámky k hovoru'),

			'after:initComponent'() {
				let dlg = this;
				this.bodyEl.gwCreateChild({
					xtype: 'Office.CallPanel.CallCard',
					showCategory: false,
					showRightPane: false,
					call: call_data,
					'after:initComponent'() {
						this.setData(data);
					},
					afterNoteSaved() {
						// update icon after note is saved
						td.querySelector('.btn-notes').gwReplaceChildren([
							Utils.useIcon('documentwithcontentfilled')
						]);
					},
					'on:close'() {
						dlg.close();
					}
				});
			},
		});
	},
	
	async showRecordings(call) {
		let recordings = await REST.GET('calls/' + encodeURIComponent(call.id) + '/recordings');

		let dlg = new CDR.CallRecordingsDialog({
			recordingsBaseUrl: API_BASE + 'calls/' + encodeURIComponent(call.id) + '/recordings/',
		});

		dlg.setRecordings(recordings);
	},

	/*
	 * Update URL query parameters from the input fields.
	 */
	updateParams() {
		Application.route({
			resolve: false,
			paramsFn: params => {
				for (let f of this.getLiveToolbarSearchFields()) {
					f.toParams(params);
				}

				return params;
			},
		});
	},

	maxCalls: 3000,

	buildQuery() {
		let query = {
			limit: this.maxCalls,
		};

		for (let f of this.getLiveToolbarSearchFields()) {
			f.toQuery(query);
		}

		if (this.full) {
			query.full = '1';
		}

		return query;
	},

	async reload() {
		let list = await REST.GET('calls', this.buildQuery());
		if (list.length >= this.maxCalls) {
			Application.notify({
				text: _('Pokoušíte se zobrazit více jak {max} hovorů, pro jejich získání použijte export do XLSX, nebo použijte jiný filtr.')
					.replace('{max}', this.maxCalls),
			});
		}

		for (let call of list) {
			
			call.source = [
				call.source_callback_case && _('Callback'),
				call.source_outbound_campaign && _('Kampaň') + ' ' + call.source_outbound_campaign.name
			].filter(s => s).join(', ');
			
			let cat = call.call_category;

			call.category1 = cat ? cat[0].name : '';
			call.category2 = (cat && cat[1]) ? cat[1].name : '';

			call.caller_name = call.caller && call.caller.name;
			call.callee_name = call.callee && call.callee.name;
			call.last_callee_name = call.last_callee && call.last_callee.name;

			call.caller_company = call.caller && call.caller.company;
			call.callee_company = call.callee && call.callee.company;
			call.last_callee = call.last_callee && call.last_callee.company;

			call.caller = call.caller && call.caller.number;
			call.callee = call.callee && call.callee.number;
			call.last_callee = call.last_callee && call.last_callee.number;
		}

		this.table.setData(list);
	},

	async applyParams(params) {
		for (let f of this.getLiveToolbarSearchFields()) {
			f.fromParams(params);
		}
	},
});

// }}}
// {{{ CDR.CallInfoScreen

GW.define('CDR.CallInfoScreen', 'Main.Screen', {
	title: _('CDR'),
	titleIcon: 'phone-calls-filled',

	'after:initComponent'() {
		this.bodyEl.gwCreateChild({
			className: 'content-container',
			children: [{
				nodeName: 'h2',
				textContent: _('Nahrávky'),
			}, {
				ref: 'table',
				xtype: 'CDR.CallRecordingsTable',
			}],
		}, this);
	},

	setData(call) {
		this.titleEl.textContent = _('Hovor') + ' ' + call.caller + ' -> ' + call.callee;

		this.table.recordingsBaseUrl = API_BASE + 'calls/' + encodeURIComponent(call.call_id) + '/recordings/';
		this.table.setData(call.recordings);
	},
});

// }}}
// {{{ Routes

Application.addRoutes([{
	group: 'auth',
	module: 'cdr',
	path: APP_BASE + 'cdr',
	async handler({params}) {
		let c = Application.show({
			id: 'cdr.history',
			xtype: 'CDR.HistoryScreen',
		});

		c.applyParams(params);
	}    
}, {
	group: 'auth',
	module: 'cdr',
	path: APP_BASE + 'cdr/call-info/{call_id:str}',
	async handler({params, captures}) {
		let call_id = captures.call_id;
		try {
			let call = await REST.GET('calls/' + encodeURIComponent(call_id));
			call.recordings = await REST.GET('calls/' + encodeURIComponent(call_id) + '/recordings');

			let c = Application.show({
				id: 'cdr.callinfo',
				xtype: 'CDR.CallInfoScreen',
			});

			c.setData(call);
		} catch (ex) {
			let c = Application.show({
				id: 'cdr.callinfo.notfound',
				xtype: 'Main.Screen',
				title: _('CDR'),
				titleIcon: 'phone-calls-filled',

				'after:initComponent'() {
					this.bodyEl.gwCreateChild({
						className: 'cdr-call-info-not-found',
						textContent: _('Hovor nebyl nalezen, nebo k němu nemáte přístup'),
					}, this);
				},
			});
		}
	}    
}]);

// }}}

Application.registerModule({
	id: 'cdr',
	title: _('CDR'),
	tagline: _('Historie hovorů ústředny'),
	icon: 'phone-calls',
	href: APP_BASE + 'cdr',
});

// Full CDR

Application.addRoutes([{
	group: 'auth',
	module: 'fullcdr',
	path: APP_BASE + 'fullcdr',
	async handler({params}) {
		let c = Application.show({
			id: 'cdr.history',
			title: _('CDR Asterisk'),
			xtype: 'CDR.HistoryScreen',
			full: true,
		});

		c.applyParams(params);
	},
}]);

Application.registerModule({
	id: 'fullcdr',
	title: _('CDR Asterisk'),
	tagline: _('Úplná historie hovorů ústředny'),
	icon: 'phone-calls',
	href: APP_BASE + 'fullcdr',
});
